/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const customEventRemoteLookupSchema = z.any();

export const customEventRemoteLookupIdSchema = z.string();

export const customEventRemoteLookupItemSchema = z.object({
  indexed_name: z.string(),
  name: z.string(),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "deleting", "deleted", "blocklisting", "blocklisted"]),
  internal_id: common.objectId,
});

export const customEventRemoteLookupFiltersSchema = z.object({});

export const customEventRemoteLookupValidators = {
  id: customEventRemoteLookupIdSchema,
  item: customEventRemoteLookupItemSchema,
  filters: customEventRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 5f4e2bec26024788a43aa4b6cc22f8b4 */
